import React, { useState, useEffect } from 'react';
import { getIdleAnalysis } from '../../services/StrategiesService';

// Card do DETECTOR DE OCIOSIDADE: só aparece quando o bot está OCIOSO e explica se é por DESIGN (mercado num
// regime que a estratégia spot corretamente evita — queda/alta-vol, ou filtro BTC) ou por PROBLEMA (sem foco,
// breaker, capital). Complementa o OperationalHealthPanel (infra) respondendo "por que não está operando?".
// Ver backend utils/idleAnalysis. READ-ONLY.
function IdleStatusCard({ refreshTick }) {
    const [data, setData] = useState(null);

    useEffect(() => {
        let alive = true;
        getIdleAnalysis().then(d => { if (alive) setData(d); }).catch(() => { });
        return () => { alive = false; };
    }, [refreshTick]);

    if (!data || !data.idle) return null;   // operando normal → não polui o dashboard

    const design = data.byDesign;
    const ctx = data.context || {};

    return (
        <div className='card border-0 shadow mb-4'>
            <div className='card-body py-3'>
                <h6 className='mb-1 fw-bold'>
                    {design ? '😴 Bot ocioso — por design' : '⚠️ Bot ocioso — vale verificar'}
                </h6>
                <p className='text-muted mb-2' style={{ fontSize: 13 }}>{data.verdict}</p>

                <div className='d-flex flex-column gap-2'>
                    {(data.reasons || []).map((r, i) => (
                        <div key={i} style={{ fontSize: 13 }}>
                            <span className={`badge ${r.byDesign ? 'bg-info' : 'bg-warning text-dark'} me-2`} style={{ fontSize: 10 }}>
                                {r.byDesign ? 'Por design' : 'Problema'}
                            </span>
                            {r.message}
                            {r.suggestion && <div className='text-muted ms-4 mt-1' style={{ fontSize: 12 }}>💡 {r.suggestion}</div>}
                        </div>
                    ))}
                </div>

                {ctx.btcRegime && (
                    <div className='mt-2 text-muted' style={{ fontSize: 11 }}>
                        BTC: {ctx.btcRegime} · Foco: {(data.focusSymbols || []).length} símbolo(s) · Livre: {ctx.freeQuote != null ? `${ctx.freeQuote} USDT` : '—'}
                    </div>
                )}
            </div>
        </div>
    );
}

export default IdleStatusCard;
